import _asyncToGenerator from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator";
import toBN from '../../toBN';
var MIN_EXTRA_GAS = 10;
var MAX_EXTRA_GAS = 100;

var currentGasPrice = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(web3, extraPercentageGas) {
    var gas, multiplier100;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return web3.eth.getGasPrice();

          case 2:
            gas = _context.sent;

            // -> current gas
            if (!extraPercentageGas || extraPercentageGas < MIN_EXTRA_GAS) {
              extraPercentageGas = MIN_EXTRA_GAS;
            }

            if (extraPercentageGas > MAX_EXTRA_GAS) {
              extraPercentageGas = MAX_EXTRA_GAS;
            }

            multiplier100 = Math.round(100 + extraPercentageGas);
            gas = toBN(gas).mul(toBN(multiplier100.toString())).div(toBN('100')); // eslint-disable-next-line consistent-return

            return _context.abrupt("return", gas);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function currentGasPrice(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default currentGasPrice;